export default "__VITE_ASSET__BF1B8XB8__"